import BaseStore from '@/store/base-store'
let options = {}

export default new BaseStore('presentations', options)



// WEBPACK FOOTER //
// ./src/store/modules/presentations.store.js